export default __webpack_public_path__ + "static/media/expandArrow.c1f01b33.svg";